export default "__VITE_ASSET__26175c1f__"